const getPartType = (char) => {
  if (char === '-') return 'minus';
  if (char === '+') return 'plus';
  return 'text';
};

const formatBenefitNumber = (value = '') => `${value}`.split('').map((char) => ({
  text: char,
  type: getPartType(char),
}));

export default formatBenefitNumber;
